<div class="promo-banner" (click)="goToPromo()">
  <div class="promo-icon red-icon-bg">
    <img src="/assets/images/icons/gift.svg" />
  </div>
  <div class="info">
    <h2>{{ campaign.attributes.name }}</h2>
    <div class="caption">
      <app-remaining-time-label [start]="campaign.attributes.start_date" [end]="campaign.attributes.end_date"></app-remaining-time-label>
      {{
        (campaign.attributes.opted_in ? 'PROMO.statusParticipating' : 'PROMO.mainOffer')
          | translate: { amount: highestAmount | translateNumber: language:currency }
      }}
    </div>
  </div>
  <div class="icon-i-chevron-right"></div>
</div>
